module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/fluent-app-icon-11.75b2fece.png";